import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AppStatePage, StatusPanel } from "./auth/AuthLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    // Don't redirect yet: the session is still being read (Figma "Web · Loading").
    return (
      <AppStatePage>
        <div role="status"><StatusPanel icon="spinner" title="Opening Aithlo…" /></div>
      </AppStatePage>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
